import { Component, ViewChild, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

import { ProductAccountService } from 'src/app/services/subscription/product-account.service';
import { PopupService } from 'src/app/services/general/popup.service';
import { AccountProductList } from 'src/app/commons/product';

@Component({
  selector: 'app-product-account-detail',
  templateUrl: './product-account-detail.component.html',
  styleUrls: ['./product-account-detail.component.scss'],
})
export class ProductAccountDetailComponent implements OnInit, OnDestroy {

  /**
   * product list
   */
  productList = AccountProductList;
  /**
   * Product ID
   */
  productId: string;
  /**
   * Purchase mode
   */
  purchaseMode: boolean;
  /**
   * Slider config
   */
  sliderConfig: any;
  /**
   * Disable slider previous btn
   */
  disablePrevBtn: boolean;
  /**
   * Disable slider next btn
   */
  disableNextBtn: boolean;
  /**
   * Upgrade Mode
   */
  upgradeMode: boolean;

  /**
   * Constructor
   * @param platform platform
   * @param modalController modal controller
   */
  constructor(
    private ngZone: NgZone,
    private platform: Platform,
    private modalController: ModalController,
    private translate: TranslateService,
    private productAccountService: ProductAccountService,
    private popupService: PopupService
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  /**
   * Before view enter
   */
  ionViewWillEnter() {
    if (!this.upgradeMode && this.productAccountService.upgradeMode) {
      this.upgradeMode = true;
    }
  }

  /**
   * Validate product ID
   * @returns true if valid product
   */
  async validateProductId(): Promise<boolean> {
    if (this.productId) {
      const productId = this.productAccountService.validateProductId(this.productId);
      return productId ? true : false;
    }
    return false;
  }

  /**
   * Dismiss couple modal
   */
  async dismissModal(productId?: string) {
    if (this.modalController) {
      const modal = await this.modalController.getTop();
      if (modal) { await modal.dismiss({ productId }); }
    }
  }

  /**
   * Select product
   */
  async selectProduct() {
    if (await this.validateProductId()) {
      this.dismissModal(this.productId);
    } else {
      if (this.productId === 'wedding_account_app' && !this.platform.is('hybrid')) {
        this.popupService.presentAlert(this.translate.instant('PRODUCT.account.msg.app_required'));
      } else if (this.productId === 'wedding_account_web' && this.platform.is('hybrid')) {
        this.popupService.presentAlert(this.translate.instant('PRODUCT.account.msg.web_required'));
      }
    }
  }

}
